export default __webpack_public_path__ + "static/media/empty-messages-icon.617cea8a.svg";